export default __webpack_public_path__ + "static/media/mainBgBaby.dbdb63cd.png";